import { ActivatedRouteSnapshot } from '@angular/router';

export const getRouteData = (route: ActivatedRouteSnapshot) => ({
  ...route.data,
  ...route.children.reduce((acc, child) => ({ ...getRouteData(child), ...acc }), {})
});
